<template>
    <div class="d-flex">
        <button
            @click="toggleInput('minus')"
            :aria-label="$t('basket.minus')"
            class="input-toggle input-toggle-minus"
        >
            -
        </button>
        <input
            v-model.number="inputValue"
            @change="updateValue"
            type="number"
            :class="[
                {
                    'input-disabled': multiply > 1,
                },
                'input-toggle input-toggle-value js-input-value'
            ]"
            aria-hidden="true"
        >
        <button
            @click="toggleInput('plus')"
            :aria-label="$t('basket.plus')"
            class="input-toggle input-toggle-plus"
        >
            +
        </button>
    </div>
</template>

<script>
    export default {
        name: 'InputToggle',
        data() {
            return {
                inputValue: this.value,
            };
        },
        props: {
            minValue: {
                type: Number,
                default: 1,
            },
            multiply: {
                type: Number,
                default: 1,
            },
            value: {
                required: true,
                default: 1,
            },
        },
        methods: {
            toggleInput(type) {
                if (type === 'minus') {
                    this.inputValue = Math.max(this.inputValue -= (1 * this.multiply), this.minValue);
                } else {
                    this.inputValue += (1 * this.multiply);
                }

                this.updateValue();
            },

            updateValue() {
                this.inputValue = Math.max(this.inputValue, this.minValue);
                this.$emit('updateValue', Math.max(this.inputValue, this.minValue));
            },
        },
        watch: {
            value() {
                this.inputValue = Math.max(this.value, this.minValue);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .input-disabled {
        pointer-events: none;
    }
</style>
